/**
 * Palette configuration based on the existing CSS custom properties
 * @param {boolean} darkMode - Whether to use dark mode
 * @returns {object} MUI palette object
 */
export const palette = (darkMode = false) => ({
  mode: darkMode ? 'dark' : 'light',
  primary: {
    50: '#e6f7ff',
    100: '#b3ecff',
    200: '#80e0ff',
    300: '#4dd4ff',
    400: '#26c5f5',
    main: '#118ab2',
    500: '#118ab2',
    600: '#0e7494',
    700: '#0c5e76',
    800: '#094858',
    900: '#07323a',
    950: '#051e24',
    contrastText: '#ffffff',
  },
  secondary: {
    main: '#073b4c',
    light: '#0f525f',
    dark: '#052a35',
    contrastText: '#ffffff',
  },
  error: {
    50: '#fef5f7',
    100: '#fce7eb',
    main: '#ef476f',
    500: '#ef476f',
    600: '#e7305a',
    700: '#d11d47',
    900: '#a1153a',
    contrastText: '#ffffff',
  },
  warning: {
    50: '#fffef5',
    100: '#fffce6',
    main: '#ffd166',
    500: '#ffd166',
    600: '#e6bc5a',
    700: '#cc9f47',
    900: '#997533',
    contrastText: '#000000',
  },
  accent: {
    pink: '#ef476f',
    yellow: '#ffd166',
    mint: '#06d6a0',
    blue: '#118ab2',
    navy: '#073b4c',
  },
  success: {
    50: '#ecfdf5',
    100: '#d1fae5',
    main: '#06d6a0',
    500: '#06d6a0',
    600: '#05c190',
    700: '#059669',
    900: '#064e3b',
    contrastText: '#ffffff',
  },
  info: {
    50: '#eff6ff',
    100: '#dbeafe',
    main: '#3b82f6', // 500
    500: '#3b82f6',
    600: '#2563eb',
    700: '#1d4ed8',
    900: '#1e3a8a',
    contrastText: '#ffffff',
  },
  grey: {
    50: darkMode ? '#030712' : '#f9fafb',
    100: darkMode ? '#111827' : '#f3f4f6',
    200: darkMode ? '#1f2937' : '#e5e7eb',
    300: darkMode ? '#374151' : '#d1d5db',
    400: darkMode ? '#4b5563' : '#9ca3af',
    500: darkMode ? '#6b7280' : '#6b7280',
    600: darkMode ? '#9ca3af' : '#4b5563',
    700: darkMode ? '#d1d5db' : '#374151',
    800: darkMode ? '#e5e7eb' : '#1f2937',
    900: darkMode ? '#f3f4f6' : '#111827',
    950: darkMode ? '#f9fafb' : '#030712',
  },
  background: {
    default: darkMode ? '#111827' : '#ffffff',
    paper: darkMode ? '#1f2937' : '#ffffff',
    subtle: darkMode ? '#1f2937' : '#f9fafb',
    tertiary: darkMode ? '#374151' : '#f3f4f6',
    disabled: darkMode ? '#374151' : '#f3f4f6',
  },
  text: {
    primary: darkMode ? '#f3f4f6' : '#111827',
    secondary: darkMode ? '#9ca3af' : '#6b7280',
    tertiary: darkMode ? '#6b7280' : '#9ca3af',
    disabled: darkMode ? '#4b5563' : '#d1d5db',
  },
  divider: darkMode ? '#374151' : '#e5e7eb',
  border: {
    primary: darkMode ? '#374151' : '#d1d5db',
    secondary: darkMode ? '#4b5563' : '#e5e7eb',
    error: darkMode ? '#7f1d1d' : '#fca5a5',
  },
});